import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import _ from 'lodash';
import queryString from 'query-string';
import moment from 'moment';
import DropZone from '../../components/DropZone';
import ListOfCompany from '../../components/ListOfCompany';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import StatusTribute from '../../components/StatusTribute';
import { formatDate, formatDate2 } from '../../utils/common';
import { instanceAxios } from '../../InstanceAxios';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = (theme) => ({
  root: {
    height: '100vh',
    overflow: 'auto',
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  selectTipo: {
    width: 200,
  },
  modalAddTitle: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 2),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  liberado: {
    backgroundColor: '#32CD32',
  },
  nliberado: {
    backgroundColor: '#FF0000',
  },
});

class DasManualComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
  }

  state = {
    das: [],
    originalDas: [],
    filterText: '', // Filter text
    isModalOpen: false, // Modal open state
    modalPosition: { top: 0, left: 0 }, // Position of the modal
    modalColumnId: null,
    orderBy: '', // Coluna pela qual estamos ordenando
    columns: [
      {
        id: 'liberado',
        label: 'Liberado',
        minWidth: 70,
        filterable: true,
        path: 'liberado',
      },
      {
        id: 'tipo_documento',
        label: 'Documento',
        minWidth: 70,
        filterable: true,
      },
      { id: 'referencia', label: 'Referente', minWidth: 70, filterable: true },
      { id: 'vencimento', label: 'Vencimento', minWidth: 70, filterable: true },
      { id: 'status', label: 'Status', minWidth: 70, filterable: true },
      { id: 'valor', label: 'Valor Total', minWidth: 70, filterable: true },
      {
        id: 'valorPrincipal',
        label: 'Valor Principal',
        minWidth: 70,
        filterable: true,
      },
      {
        id: 'valorMulta',
        label: 'Valor Multa',
        minWidth: 70,
        filterable: true,
      },
      {
        id: 'valorJuros',
        label: 'Valor Juros',
        minWidth: 70,
        filterable: true,
      },
      { id: 'editar', label: 'Editar', minWidth: 50, filterable: true },
      { id: 'download', label: 'Download', minWidth: 50, filterable: true },
      { id: 'excluir', label: 'Excluir', minWidth: 50, filterable: true },
    ],
    anos: _.range(2015, new Date().getFullYear() + 1),
    cnpjUsuario: '',
    nomeEmpresa: '',
    mes: moment().format('M'),
    ano: moment().format('YYYY'),
    vencimento: '',
    tipo_documento: '',
    codigoBarra: '',
    status: '',
    valor: '0',
    principal: '0',
    juros: '0',
    multa: '0',
    idDas: null,
    openWarning: false,
    openError: false,
    openSucess: false,
    openModal: false,
    openValid: false,
    msgValid: '',
    openModalAddFile: false,
    openModalAddFileApuracao: false,
    ready: true,
    fileSelect: '',
    fileName: '',
    fileSelectApuracao: '',
    fileNameApuracao: '',
    liberado: true,
  };

  UNSAFE_componentWillMount() {
    if (this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      this.setState({
        cnpj: values.cnpj,
        nomeEmpresa: values.razao,
      });
      this.handleSelectUsuario(values.cnpj);
    }
  }

  handleSelectUsuario = async (cnpj) => {
    this.setState({ cnpjUsuario: cnpj });
    this.setState({ ready: false });
    await this.axios
      .get(`${environment}/das/${cnpj}/all`)
      .then((res) => {
        const das = res.data;
        console.log('das > ', das);
        this.setState({ das });
        this.setState({ originalDas: das });
        this.setState({ ready: true });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  handleEdit = (das) => {
    const vencimento =
      das.vencimento === '-' ? das.vencimento : formatDate2(das.vencimento);
    this.setState({ idDas: das.id });
    this.setState({ cnpjUsuario: das.cnpj });
    this.setState({ mes: das.mes });
    this.setState({ ano: das.ano });
    this.setState({ vencimento });
    this.setState({ codigoBarra: das.codigoBarra });
    this.setState({ valor: das.valor });
    this.setState({ status: das.status });
    this.setState({ tipo_documento: das.tipo_documento });
    this.setState({ principal: das.principal });
    this.setState({ juros: das.juros });
    this.setState({ multa: das.multa });
    this.setState({ liberado: das.liberado });
    this.setState({ fileName: das.caminho });
    this.setState({ fileSelect: das.caminho });
    this.setState({ fileNameApuracao: das.apuracao });
    this.setState({ fileSelectApuracao: das.apuracao });
    this.handleModal();
  };

  handleButtonClick = async (file) => {
    this.setState({ openModalAddFile: false });
    if (file) {
      this.setState({ fileSelect: file[0] });
      this.setState({ fileName: file[0].name });
    }
  };

  handleButtonClickApuracao = async (fileApuracao) => {
    this.setState({ openModalAddFileApuracao: false });
    if (fileApuracao) {
      this.setState({ fileSelectApuracao: fileApuracao[0] });
      this.setState({ fileNameApuracao: fileApuracao[0].name });
    }
  };

  handleSaveClick = async () => {
    if (this.state.status === 'A Vencer' || this.state.status === 'Devedor') {
      if (
        this.state.codigoBarra === '' ||
        this.state.valor === '' ||
        this.state.fileName === ''
      ) {
        this.setState({ msgValid: 'Preencha todos os campos necessários' });
        return false;
      }
    }
    if (!this.isValid()) {
      this.setState({ openValid: true });
      return;
    }
    this.setState({ ready: !this.state.ready });
    const data = new FormData();
    if (this.state.fileSelect) data.append('file', this.state.fileSelect);
    if (this.state.fileSelectApuracao)
      data.append('fileApuracao', this.state.fileSelectApuracao);
    data.append('id', this.state.idDas);
    data.append('cnpj', this.state.cnpjUsuario);
    data.append('mes', this.state.mes);
    data.append('ano', this.state.ano);
    data.append('status', this.state.status);
    data.append('tipo_documento', this.state.tipo_documento);
    data.append(
      'vencimento',
      this.state.vencimento ? formatDate(this.state.vencimento) : null
    );
    data.append('codigo_barra', this.state.codigoBarra);
    data.append('liberado', this.state.liberado);
    data.append(
      'valor',
      this.state.valor ? Number(this.state.valor.replace(',', '.')) : null
    );
    data.append(
      'principal',
      this.state.principal
        ? Number(this.state.principal.replace(',', '.'))
        : null
    );
    data.append(
      'juros',
      this.state.juros ? Number(this.state.juros.replace(',', '.')) : null
    );
    data.append(
      'multa',
      this.state.multa ? Number(this.state.multa.replace(',', '.')) : null
    );

    console.log(
      this.state.valor ? Number(this.state.valor.replace(',', '.')) : null
    );
    console.log(
      this.state.principal ? Number(this.state.valor.replace(',', '.')) : null
    );
    console.log(
      this.state.juros ? Number(this.state.valor.replace(',', '.')) : null
    );
    console.log(
      this.state.multa ? Number(this.state.valor.replace(',', '.')) : null
    );
    await this.axios
      .post(`${environment}/dasFile/`, data)
      .then((res) => {
        this.setState({ openModal: false });
        this.setState({ openModalAddFile: false });
        this.setState({ openModalAddFileApuracao: false });
        this.setState({ openSucess: true });
        this.clearData();
        this.handleSelectUsuario(this.state.cnpjUsuario);
        this.setState({ ready: true });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ openModal: false });
        this.setState({ openModalAddFile: false });
        this.setState({ openModalAddFileApuracao: false });
        this.setState({ openSucess: false });
        this.setState({ openError: true });
        this.clearData();
        this.setState({ ready: true });
      });
  };

  isValid = () => {
    if (
      this.state.status === 'Em Parcelamento' ||
      this.state.status === 'Declaração Zerada'
    ) {
      return true;
    }
    const valor = Number(this.state.valor.replace(',', '.'));
    const principal = Number(this.state.principal.replace(',', '.'));
    const juros = Number(this.state.juros.replace(',', '.'));
    const multa = Number(this.state.multa.replace(',', '.'));

    if (
      this.state.cnpjUsuario &&
      this.state.mes &&
      this.state.ano &&
      this.state.status
    ) {
      if (valor.toFixed(2) !== (principal + juros + multa).toFixed(2)) {
        this.setState({ msgValid: 'Soma dos valores não batendo!' });
        return false;
      }

      return true;
    }

    if (this.state.status === 'A Vencer' || this.state.status === 'Devedor') {
      if (
        this.state.codigoBarra === '' ||
        this.state.valor === '' ||
        this.state.fileName === ''
      ) {
        this.setState({ msgValid: 'Preencha todos os campos necessários' });
        return false;
      }
    }

    this.setState({ msgValid: 'Preencha todos os campos necessários' });
    return false;
  };

  handleModal = () => {
    const status = !this.state.openModal;
    this.setState({ openModal: status, liberado: status });
  };

  handleClose = () => {
    this.setState({ openModal: false });
    this.setState({ openModalAddFile: false });
    this.setState({ openModalAddFileApuracao: false });
    this.clearData();
  };

  handleAddFile = (classes) => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModalAddFile}
        onClose={() => this.setState({ openModalAddFile: false })}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={this.handleButtonClick} />
        </div>
      </Modal>
    );
  };

  handleAddFileApuracao = (classes) => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModalAddFileApuracao}
        onClose={() => this.setState({ openModalAddFileApuracao: false })}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={this.handleButtonClickApuracao} />
        </div>
      </Modal>
    );
  };

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
    this.setState({ openValid: false });
  };

  excluirDas = async (das) => {
    this.setState({ ready: false });
    await this.axios
      .delete(`${environment}/das/${das.id}`)
      .then((res) => {
        const d = this.state.das.filter((d) => d.id !== das.id);
        this.setState({ das: d });
        this.setState({ openSucess: true });
        this.setState({ ready: true });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  clearData = () => {
    this.setState({ vencimento: '' });
    this.setState({ codigoBarra: '' });
    this.setState({ status: '' });
    this.setState({ tipo_documento: '' });
    this.setState({ openModal: false });
    this.setState({ principal: '0' });
    this.setState({ juros: '0' });
    this.setState({ multa: '0' });
    this.setState({ valor: '0' });
    this.setState({ file: '' });
    this.setState({ fileApuracao: '' });
    this.setState({ fileName: '' });
    this.setState({ fileNameApuracao: '' });
    this.setState({ mes: moment().format('M') });
    this.setState({ ano: moment().format('YYYY') });
    this.setState({ idDas: null });
  };

  openModal = (event, columnid) => {
    this.setState({ filterText: '' });
    const rect = event.target.getBoundingClientRect();
    this.setState({
      isModalOpen: true,
      modalPosition: { top: rect.bottom, left: rect.left },
      modalColumnId: columnid,
    });
  };

  handleFilterTextChange = (event) => {
    this.setState({ filterText: event.target.value });
  };

  // Function to filter the table data
  filterTable = () => {
    this.setState({ isModalOpen: false });
    const { das, filterText, modalColumnId } = this.state;
    const filteredDas = das.filter((item) => {
      const value = this.getValueColumnId(modalColumnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    this.setState({ das: filteredDas });
  };

  getValueColumnId(columnId, rowData) {
    columnId = columnId.replace(/"/g, '');
    const parts = columnId.split('.');
    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  }
  clearFilter = () => {
    this.setState({ isModalOpen: false });
    this.setState({ filterText: '', das: this.state.originalDas });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleRequestSort = (property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  sortTable = (property) => {
    const { das, order } = this.state;
    const isAsc = order === 'asc';
    das.sort((a, b) => {
      let aValue = this.getValueColumnId(property, a);
      let bValue = this.getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
      }
      if (typeof bValue === 'string') {
        bValue = bValue.toLowerCase();
      }

      if (aValue == null) {
        return isAsc ? -1 : 1;
      }

      if (bValue == null) {
        return isAsc ? 1 : -1;
      }

      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    this.setState({ das });
  };

  render() {
    const { classes } = this.props;

    const GreenSwitch = withStyles({
      switchBase: {
        color: this.state.liberado ? '#32CD32' : '##FF0000',
        '&$checked': {
          color: this.state.liberado ? '#32CD32' : '##FF0000',
        },
        '&$checked + $track': {
          backgroundColor: '#32CD32',
        },
      },
      checked: {},
      track: {},
    })(Switch);

    return (
      <div
        style={{
          margin: 20,
        }}
      >
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          style={{
            top: this.state.modalPosition.top,
            left: this.state.modalPosition.left,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '5px',
              width: '300px',
            }}
          >
            <TextField
              label="Filtrar"
              variant="outlined"
              value={this.state.filterText}
              onChange={this.handleFilterTextChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.filterTable}
              style={{ marginTop: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.clearFilter}
              style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
            >
              Limpar
            </Button>
          </div>
        </Modal>
        <h1 style={{ textAlign: 'center' }}>DAS</h1>
        <Collapse in={this.state.openError}>
          <Alert severity="error" onClick={this.clickAlert}>
            Erro ao Salvar/Excluir Das!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openWarning}>
          <Alert severity="warning" onClick={this.clickAlert}>
            Arquivo Não Encontrado
          </Alert>
        </Collapse>
        <Collapse in={this.state.openSucess}>
          <Alert severity="success" onClick={this.clickAlert}>
            Das Salvo/Excluido com sucesso!
          </Alert>
        </Collapse>
        <Collapse in={this.state.ready}>
          <Paper className={classes.root}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: 10,
              }}
            >
              <ListOfCompany
                label="Empresa do Cliente *"
                width="40%"
                companySelect={this.state.nomeEmpresa}
                setCompanySelect={(nome) => {
                  this.setState({ nomeEmpresa: nome });
                }}
                setCnpj={(cnpj) => this.handleSelectUsuario(cnpj)}
                assinantes
              />
              <Button
                disabled={this.state.cnpjUsuario === ''}
                style={{
                  backgroundColor: XMEI_PRIMARY_COLOR,
                  color: '#FFF',
                  marginTop: 10,
                  marginBottom: 10,
                }}
                variant="contained"
                onClick={this.handleModal}
              >
                Adicionar
              </Button>
            </div>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sortDirection={
                        this.state.orderBy === column.id
                          ? this.state.order
                          : false
                      }
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TableSortLabel
                          active={this.state.orderBy === column.id}
                          direction={
                            this.state.orderBy === column.id
                              ? this.state.order
                              : 'asc'
                          }
                          onClick={() => {
                            this.handleRequestSort(column.id);
                            setTimeout(() => {
                              this.sortTable(column.id);
                            }, 200);
                          }}
                        >
                          {column.label}
                        </TableSortLabel>

                        {column.filterable && (
                          <IconButton
                            style={{ marginLeft: -18 }}
                            onClick={(event) =>
                              this.openModal(event, column.id)
                            }
                            aria-label="filtra"
                          >
                            <FilterIcon style={{ width: 16, height: 16 }} />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.das.map((d) => {
                  return (
                    <TableRow key={d.id}>
                      <TableCell component="th" scope="row">
                        {d.liberado ? (
                          <Chip
                            label="Sim"
                            color="primary"
                            className={classes.liberado}
                          />
                        ) : (
                          <Chip
                            label="Não"
                            color="primary"
                            className={classes.nliberado}
                          />
                        )}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {d.tipo_documento}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {`${d.mes}/${d.ano}`}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {d.vencimento ? d.vencimento : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <StatusTribute status={d.status} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {isNaN(d.valor) || !d.valor ? '-' : d.valor}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {isNaN(d.principal) || !d.principal ? '-' : d.principal}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {isNaN(d.multa) || !d.multa ? '-' : d.multa}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {isNaN(d.juros) || !d.juros ? '-' : d.juros}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Button
                          size="small"
                          color="primary"
                          target="blank"
                          onClick={() => this.handleEdit(d)}
                        >
                          Editar
                        </Button>
                      </TableCell>
                      <TableCell>
                        {d.caminho ? (
                          <IconButton
                            aria-label="download"
                            onClick={() => window.open(d.caminho, '_blank')}
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        ) : null}
                      </TableCell>
                      {/*<TableCell>*/}
                      {/*  {d.caminhoApuracao ? (*/}
                      {/*    <IconButton*/}
                      {/*      aria-label="download"*/}
                      {/*      onClick={() =>*/}
                      {/*        window.open(d.caminhoApuracao, '_blank')*/}
                      {/*      }*/}
                      {/*    >*/}
                      {/*      <CloudDownloadIcon />*/}
                      {/*    </IconButton>*/}
                      {/*  ) : null}*/}
                      {/*</TableCell>*/}
                      <TableCell>
                        <IconButton
                          aria-label="excluir"
                          onClick={() => this.excluirDas(d)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.openModal}
            onClose={this.handleClose}
          >
            <div className={classes.paper}>
              <Collapse in={this.state.openValid}>
                <Alert severity="error" onClick={this.clickAlert}>
                  {this.state.msgValid}
                </Alert>
              </Collapse>
              <Grid container spacing={1} justify="left" alignItems="left">
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <h2 id="simple-modal-title">{`Das - ${this.state.cnpjUsuario}`}</h2>
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <TextField
                    select
                    label="Mes"
                    labelId="mes"
                    fullWidth
                    id="mes"
                    value={this.state.mes}
                    style={{ width: 200 }}
                    onChange={(mes) => {
                      this.setState({ mes: mes.target.value });
                    }}
                  >
                    <MenuItem value="1">Janeiro</MenuItem>
                    <MenuItem value="2">Fevereiro</MenuItem>
                    <MenuItem value="3">Março</MenuItem>
                    <MenuItem value="4">Abril</MenuItem>
                    <MenuItem value="5">Maio</MenuItem>
                    <MenuItem value="6">Junho</MenuItem>
                    <MenuItem value="7">Julho</MenuItem>
                    <MenuItem value="8">Agosto</MenuItem>
                    <MenuItem value="9">Setembro</MenuItem>
                    <MenuItem value="10">Outubro</MenuItem>
                    <MenuItem value="11">Novembro</MenuItem>
                    <MenuItem value="12">Dezembro</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1} />
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <TextField
                    select
                    label="Ano"
                    labelId="ano"
                    value={this.state.ano}
                    id="ano"
                    onChange={(ano) => {
                      this.setState({ ano: ano.target.value });
                    }}
                    style={{ width: 200 }}
                  >
                    {this.state.anos.map((a) => {
                      return <MenuItem value={a}>{a}</MenuItem>;
                    })}
                  </TextField>
                </Grid>
              </Grid>
              <Grid container spacing={1} justify="left" alignItems="left">
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <TextField
                    label="Status"
                    select
                    style={{ width: 200 }}
                    value={this.state.status}
                    onChange={(event) => {
                      this.setState({ status: event.target.value });
                      console.log();
                      console.log();
                      console.log();
                      if (
                        event.target.value === 'Em Parcelamento' ||
                        event.target.value === 'Declaração Zerada'
                      ) {
                        console.log('!!!!!!!!!!!!!!!!!!!!!!');
                        this.setState({
                          valor: null,
                          principal: null,
                          multa: null,
                          juros: null,
                          codigoBarra: null,
                          vencimento: null,
                        });
                      }
                    }}
                  >
                    <MenuItem value="Liquidado">Liquidado</MenuItem>
                    <MenuItem value="Devedor">Devedor</MenuItem>
                    <MenuItem value="A Vencer">A Vencer</MenuItem>
                    <MenuItem value="Em Parcelamento">Em Parcelamento</MenuItem>
                    <MenuItem value="Declaração Zerada">
                      Declaração Zerada
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1} />
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <TextField
                    label="Vencimento"
                    id="vencimento"
                    style={{ width: 200 }}
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={this.state.vencimento}
                    onChange={(data) => {
                      this.setState({ vencimento: data.target.value });
                    }}
                    helperText={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                    error={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3}>
                  <TextField
                    label="Tipo documento"
                    select
                    style={{ width: 200 }}
                    value={this.state.tipo_documento}
                    onChange={(event) => {
                      this.setState({ tipo_documento: event.target.value });
                    }}
                  >
                    <MenuItem value="DAS">DAS</MenuItem>
                    <MenuItem value="PGDAS">PGDAS</MenuItem>
                    <MenuItem value="PGDASR">PGDASR</MenuItem>
                    <MenuItem value="DASMEI">DASMEI</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    label="Código de Barra"
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    value={this.state.codigoBarra}
                    fullWidth
                    onChange={(data) => {
                      this.setState({ codigoBarra: data.target.value });
                    }}
                    helperText={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                    error={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={11} sm={3} md={3} lg={3}>
                  <TextField
                    label="Valor"
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    value={this.state.valor}
                    onChange={(data) => {
                      const valor = data.target.value.replace(/[^\d,]+/g, '');
                      this.setState({ valor });
                    }}
                    helperText={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                    error={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={1} sm={9} md={9} lg={9} />
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <TextField
                    label="Valor Principal"
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    value={this.state.principal}
                    onChange={(data) => {
                      const principal = data.target.value.replace(
                        /[^\d,]+/g,
                        ''
                      );
                      this.setState({ principal });
                    }}
                    helperText={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                    error={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'Campo obrigatório'
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <TextField
                    label="Juros"
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    value={this.state.juros}
                    onChange={(data) => {
                      const juros = data.target.value.replace(/[^\d,]+/g, '');
                      this.setState({ juros });
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <TextField
                    label="Multa"
                    value={this.state.multa}
                    disabled={
                      this.state.status === 'Em Parcelamento' ||
                      this.state.status === 'Declaração Zerada'
                    }
                    onChange={(data) => {
                      const multa = data.target.value.replace(/[^\d,]+/g, '');
                      this.setState({ multa });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <GreenSwitch
                          checked={this.state.liberado}
                          onChange={(event) => {
                            this.setState({ liberado: event.target.checked });
                          }}
                          name="liberado"
                        />
                      }
                      label={this.state.liberado ? 'Liberado' : 'Não Liberado'}
                    />
                  </FormGroup>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                justify="left"
                alignItems="left"
                style={{ paddingTop: '3%' }}
              >
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <a
                    href={this.state.fileName}
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: 'block', marginBottom: '1rem' }}
                  >
                    {this.state.fileName
                      ? `LINK: ${this.state.fileName}`
                      : 'Não há arquivo'}
                  </a>

                  <Button
                    startIcon={<CloudUploadIcon />}
                    onClick={() => this.setState({ openModalAddFile: true })}
                    color={
                      this.state.status === 'A Vencer' ||
                      this.state.status === 'Devedor'
                        ? 'secondary'
                        : 'primary'
                    }
                    variant="contained"
                  >
                    Adicionar DAS
                  </Button>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <div align="right">
                    <Button
                      startIcon={<SaveIcon />}
                      onClick={this.handleSaveClick}
                      color="primary"
                      variant="contained"
                      disabled={!this.state.fileSelect && this.state.idDas}
                    >
                      Salvar
                    </Button>
                  </div>
                </Grid>
              </Grid>
              {/* Botão arquivo apuração */}
            </div>
          </Modal>
          {this.handleAddFile(classes)}
          {this.handleAddFileApuracao(classes)}
        </Collapse>
        <Collapse in={this.state.ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </div>
    );
  }
}
export default withStyles(useStyles)(DasManualComponent);
